// extracted by mini-css-extract-plugin
export default {"title":"DisbursementLogTable_title__DWxnB"};